import { render, staticRenderFns } from "./UploadDownloadLabel.vue?vue&type=template&id=5a77a391&"
import script from "./UploadDownloadLabel.vue?vue&type=script&lang=js&"
export * from "./UploadDownloadLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports